import { inject, Injectable } from '@angular/core';
import { I18nStore } from './i18n.store';
import { SupportedLanguage } from './i18n.constants';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  private readonly store = inject(I18nStore);

  get currentLanguage() {
    return this.store.currentLanguage;
  }

  get supportedLanguages() {
    return this.store.supportedLanguages;
  }

  setLanguage(language: SupportedLanguage): void {
    this.store.setLanguage(language);
  }
}
